/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { BasicMenuViewModel } from 'src/types/view-models/menu.view.model';
import { Select } from '@americanexpress/dls-react';

export default class RoundedDropdown extends Component<BasicMenuViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <Select
                disabled={this.props.disabled || false}
                onChange={this.props.onChange}
                value={this.props.value}
                className={this.props.className}
                fluid={this.props.fullWidth}
                id={this.props.id}
            >
                {this.props.children}
            </Select>
        );
    }
}
